<template>
    <a-card>
        <div style="display: flex;justify-content: space-between;">
            <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
                <a-form-item label="兑现年份" name="year">
                    <YearPicker style="width: 100%" v-model:value="searchForm.year" :format="dateFormat.DATE_YEAR"
                                :showTime="false"/>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" @click="onSearch">查询</a-button>
                    <a-button @click="onReset">重置</a-button>
                </a-form-item>
            </a-form>
            <a-button style="color:#f5561d;border:1px solid #f5561d;" @click="tipVisibleOpen"> 申报流程 </a-button>
            <div class="tip-div" v-if="tipVisible">
                <p style="line-height:30px;"><span style="color:#f5561d;">①</span>第一步：点击“ <span style="color:#f5561d;">资金使用情况表</span>”填写资金使用情况表；</p>
                <p style="line-height:30px;"><span style="color:#f5561d;">②</span>第二步：点击“<span style="color:#f5561d;">资金使用情况表下载</span>”填写后下载PDF；</p>
                <p style="line-height: 30px;"><span style="color:#f5561d;">③</span>第三步：点击“<span style="color:#f5561d;">资金追踪盖章完整版.PDF</span>”上传全套盖章版印证材料；</p>
                <p style="line-height: 30px;"><span style="color:#f5561d;">④</span>第四步：点击“<span style="color:#f5561d;">提交</span>”，等待后台审核；</p>
                <p style="line-height: 30px;"><span style="color:#f5561d;">⑤</span>第五步：点击“<span style="color:#f5561d;">查看</span>”可查看管理端审核情况。</p>
                <div class="button" @click="tipVisible = false">我知道了</div>
            </div>
        </div>
        <p style="margin-bottom: 10px;color: red">请将资金使用情况表、记账凭证、银行回单、发票、合同等印证材料一起打印盖章，点击【印证材料】上传PDF后，点击【提交】</p>
        <a-table :columns="columns"
                 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, getCheckboxProps: onGetCheckboxProps }"
                 :pagination="pagination" :data-source="dataSource" :loading="loading" @change="onTableChange">
            <template #customTitle6>
                <div>
                    印证资料
                </div>
            </template>
            <template #FundTrackingSubsidyType="{ text }">
                <dict-render :dict-obj="dictObjs['FundTrackingSubsidyType']" :text="text"></dict-render>
            </template>
<!--            <template #year="{ record }">
                <a>{{ record.year }}</a>
            </template>-->
            <template #otherFile="{ record }">
                <div style="display: flex;">
                    <span style="color:#f5561d;margin-right: 4px;margin-top:4px;" v-if="record.id !=null && !record.confirmationFile">③</span>
                    <file-upload style="margin-bottom: 5px;"
                                 v-if="record.id !=null"
                                 :dataId="record.id"
                                 @uploadSuccess="uploadSuccess"
                                  @delete="handleCustomDelete(record)"
                                 v-model:value="record.confirmationFile" :size="800" :is-pdf="true" names="资金追踪盖章完整版.PDF"/>
                </div>
            </template>
            <template #auditStatus="{ record }">
                <a-tag v-if="record.isSubmit == 0 && record.auditStatus == 0" style="color: red;cursor: pointer;">待提交</a-tag>
                <a-tag v-if="record.isSubmit != 0 && record.auditStatus == 0"  style="color: red;cursor: pointer;">待审核</a-tag>
                <a-tag v-if="record.isSubmit != 0 && record.auditStatus == 1" style="color: green;cursor: pointer;" >审核通过</a-tag>
                <a-tag v-if="record.isSubmit != 0 && record.auditStatus == 2" style="color: red;cursor: pointer;">审核不通过</a-tag>
                <!-- <span>{{ text == 0 ? '待初审' : text == 1 ? '待复审' : text == 2 ? '审核通过' : text == 3 ? '审核不通过' : '' }}</span> -->
            </template>
            <template #action="{ record }">
                <div class="table-row-operations">
                    <div>
                        <a v-if="record.id ==null" @click="onEdit(record)"><span style="color:#f5561d;">①</span>资金使用情况表</a>
                    </div>
                    <div>
                        <a v-if="record.id !=null && record.auditStatus=='2' " @click="onEdit(record)"><span style="color:#f5561d;">①</span>资金使用情况表</a>
                    </div>
                    <div>
                        <a v-if="record.id !=null && record.isSubmit=='0' " @click="onEdit(record)"><span style="color:#f5561d;">①</span>资金使用情况表</a>
                    </div>
                    <div>
                        <a v-if="record.id !=null" @click="exportExcelTemplate(record)"><span style="color:#f5561d;">②</span>资金使用情况表下载</a>
                    </div>
                    <div>
                        <a v-if="record.id !=null && record.isSubmit=='0' " key="submit" type="primary" @click="onSubmitFun(record)"><span style="color:#f5561d;">④</span>提交</a>
                    </div>
                    <div>
                        <a v-if="record.id !=null" @click="onDetail(record)"><span style="color:#f5561d;">⑤</span>查看</a>
                    </div>
                </div>
            </template>
        </a-table>
    </a-card>
    <UserModal ref="userModal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
    <DetailModal ref="detailModal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
    <StatusModal ref="statusModal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
</template>

<script>
import DetailModal from './components/DetailModal';
import UserModal from './components/newUserModal';
import StatusModal from './components/StatusModal';
import {tableListMixin, dictMixin} from "@/mixins";
import {sys_innovationsubsidy, sys_policy} from "@/api/policyService";
import {dateFormat} from "@/config/variableConfig";
import {message} from "ant-design-vue";
import {companyInfo, finance} from '@/api/companyService';
import axios from "axios";
import {ls} from "@/utils/util";
import {file_service} from "@/api/adminService";
import {sys_fundsTracking} from "../../../../api/policyService";

const columns = [
    {title: "兑现年份", dataIndex: "year", key: "year", slots: {customRender: "year"}},
    {
        title: "项目名称",
        dataIndex: "subsidyType",
        key: "subsidyType",
        slots: {customRender: "FundTrackingSubsidyType"}
    },
    {title: "资助金额（万元）", dataIndex: "amountApplied", key: "amountApplied"},
    {
        dataIndex: 'otherFile',
        slots: {title: 'customTitle6', customRender: 'otherFile'}
    },
    { title: "审核状态", width: 120, dataIndex: "auditStatus", key: "auditStatus", slots: { customRender: "auditStatus" } },
    {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},
];
export default {
    name: "index",
    mixins: [tableListMixin, dictMixin],
    components: {
        DetailModal, UserModal, StatusModal
    },
    data() {
        return {
            tipVisible:true,
            erweimaCode: '',
            dictNames: 'FundTrackingSubsidyType',
            dateFormat,
            columns,
            yearArr: [],
            queryParam: {},
            listUrl: sys_fundsTracking.pageList,
            // listKeyField: "id"
        }
    },
    mounted() {
        this.getYearData()
        this.erweimaCode = this.$ls.get('erweimaCode')
    },
    methods: {
        tipVisibleOpen(){
            this.tipVisible = !this.tipVisible
        },
        getImg(imgUrl) {
            return file_service.imagesWeb(imgUrl)
        },
        getYearData() {
            this.postAction({
                url: sys_policy.getYearData,
                params: {cashingTypeValue: '3',}
            }).then(res => {
                // console.log('res111', res)
                let arr = []
                res.map(item => {
                    arr.push({label: item + '年', value: item + ''})
                })
                this.yearArr = arr
            })
        },
        uploadSuccess(fileId, dataId) {
            this.postJson({
                url: sys_fundsTracking.updateData,
                params: {id: dataId, confirmationFile: fileId}
            })
        },
        handleCustomDelete(record){
            this.postJson({
                url: sys_fundsTracking.updateData,
                params: {id: record.id, confirmationFile: ""},
                returnMsg: true
            }).then(() => {
                this.$message.success('操作成功！');
                this.onFormEdited()
            })
        },
        onAdd() {
            if (this.yearArr.length > 0) {
                this.getAction({
                    url: companyInfo.detail
                }).then(res => {
                    if (res.companyName && res.oraganizationCode && res.detailedAddress && res.corporation) {
                        this.getAction({
                            url: finance.detail,
                            params: {
                                companyCode: this.$ls.get("companyCode")
                            }
                        }).then(aa => {
                            if (aa.bankName && aa.bankAccount && aa.bankCode) {
                                let obj = {
                                    isEdit: true,
                                    year: this.yearArr.length == 1 ? this.yearArr[0].value : undefined,
                                    yearArr: this.yearArr,
                                    companyName: res.companyName,
                                    oraganizationCode: res.oraganizationCode,
                                    detailedAddress: res.detailedAddress,
                                    openingBank: aa.bankName,
                                    accountNumber: aa.bankAccount,
                                    bankPermitFile: aa.bankPermitFile,
                                    lineNumber: aa.bankCode,
                                    subsidySVos: []
                                }
                                this.onShowModal('userModal', obj);
                            } else {
                                message.warning('请完善档案管理财务信息！')
                                this.$router.push({path: '/sys/finance'})
                            }
                        })
                    } else {
                        message.warning('请完善企业基本信息！')
                        this.$router.push({path: '/sys/companyInfo'})
                    }
                })
            } else {
                message.warning('该政策兑现未开启！')
            }
        },
        onEdit(record) {
            record.enterpriseFundExpenditureList.forEach(item=>{
                if(item.remark === ' '){
                    item.remark = ''
                }
            })
            this.onShowModal('userModal', record);
        },
        onStatus(record) {
            this.getAction({
                url: sys_innovationsubsidy.detail,
                params: {id: record.id}
            }).then(res => {
                let obj = {
                    ...res,
                    agentIdCard: res.agentIdCard ? res.agentIdCard.substr(0, 5) + '***********' + res.agentIdCard.substr(15, res.agentIdCard.split('').length) : ''
                }
                this.onShowModal('statusModal', obj);
            })
        },
        onDetail(record) {
            this.getAction({
                url: sys_fundsTracking.detail,
                params: { id: record.id }
            }).then(res => {
                /* let obj = {
                     ...res,
                     agentIdCard: res.agentIdCard ? res.agentIdCard.substr(0, 5) + '***********' + res.agentIdCard.substr(15, res.agentIdCard.split('').length) : ''
                 }*/
                this.onShowModal('detailModal', res);
            })
        },
        // onDetail(record) {
        //     this.getAction({
        //         url: sys_fundsTracking.detail
        //     }).then(corpInfo => {
        //         this.getAction({
        //             url: sys_innovationsubsidy.detail,
        //             params: {id: record.id}
        //         }).then(res => {
        //             let obj = {
        //                 ...corpInfo,
        //                 ...res,
        //                 agentIdCard: res.agentIdCard ? res.agentIdCard.substr(0, 5) + '***********' + res.agentIdCard.substr(15, res.agentIdCard.split('').length) : ''
        //             }
        //             this.onShowModal('detailModal', obj);
        //         })
        //     })
        // },
        onGetCheckboxProps(record) {
            return {
                disabled: record.isSubmit != 0, // Column configuration not to be checked
            }
        },
        onCommit(record) {
            this.postAction({
                url: sys_innovationsubsidy.commitUrl,
                params: {
                    id: record.id,
                    isSubmit: 1,
                    auditStatus: 0,
                    firstAuditStatus: 0,
                    secondAuditStatus: 0,
                    year: record.year,
                    firstAuditRemark: '',
                    secondAuditRemark: '',
                },
                returnMsg: true
            }).then(() => {
                this.$message.success('操作成功！');
                this.onFormEdited()
            })
        },
        onSubmitFun(record) {
            if(record.confirmationFile == null){
                this.$message.error('请先上传盖章文件！');
                return;
            }
            this.postJson({
                url: sys_fundsTracking.updateData,
                params: {id: record.id, auditStatus: 0,isSubmit: 1, firstAuditRemark: ""}
            })
            this.onSearch();
        },
        getMoban(record) {
            axios({
                methods: "get",
                url: sys_policy.ziliaoDownload,
                params: {
                    subsidyId: record.id,
                    cashingType: '3'
                },
                responseType: 'arraybuffer',
                headers: {
                    // 'content-type': 'application/x-www-form-urlencoded',
                    Authorization: 'Bearer' + ls.get('token') || ''
                }
            }).then(data => {
                const blob = new Blob([data.data], {type: "application/pdf"});
                const url = window.URL.createObjectURL(blob);
                window.open(url)
                // const link = document.createElement("a"); // 创建a标签
                // link.href = url;
                // link.download = decodeURIComponent('双创载体培育高企补贴申请资料.pdf');// 文件重命名，若无需重命名，将该行删去
                // link.click();
                // URL.revokeObjectURL(url); // 释放内存
            })
        }, exportExcelTemplate(record) {
            axios({
                methods: 'get',
                url: sys_fundsTracking.ziliaoDownload,
                params: {
                    id: record.id
                },
                responseType: 'blob',
                headers: {
                    // 'content-type': 'application/x-www-form-urlencoded',
                    Authorization: 'Bearer' + ls.get('token') || ''
                }
            }).then(data => {
                const blob = new Blob([data.data], {type: "application/pdf"});
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a"); // 创建a标签
                link.href = url;
                link.download = decodeURIComponent('资金使用情况表.pdf');// 文件重命名，若无需重命名，将该行删去
                link.click();
                URL.revokeObjectURL(url); // 释放内存

            })
        },
    }
}
</script>
<style scoped lang="less">
.tip-div{
  width: 260px;
  position: absolute;
  right:120px;
  top:25px;
  background: #fff;
  z-index: 999;
  box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  padding: 12px;
  background-clip: padding-box;
  border-radius: 8px;
  .button{
      text-align: center;
      margin:10px 0 0  0;
      color:#1890ff;
      cursor: pointer;
      font-size: 18px;
 }
}
</style>
